<template>
  <div class="pt-6">
    <fieldset id='agb'>
      <div class="mt-4">
        <div class="relative flex items-start">
          <div class="flex items-center h-5">
            <input type="checkbox"
                   id="start_termsAccepted"
                   name="start_termsAccepted"
                   v-model="modelValue"
                   class="focus:ring-blue-700 h-4 w-4 text-blue-700 border-gray-400 rounded"
            >
          </div>
          <div class="ml-3 text-sm">
            <label for="start_termsAccepted" class="sr-only">Datenschutz und
              AGB</label>
            <p class="text-gray-500">Ich habe die
              <span class="text-green-400 hover:text-green-300">
                <a target="_blank" href="/datenschutz">Datenschutzbestimmungen</a>
              </span>, <span class="text-green-400 hover:text-green-300">
                <a target="_blank" href="/files/vertragsunterlagen_heysafe.pdf">Versicherungsbedigungen</a>
              </span> und <span class="text-green-400 hover:text-green-300"><a target="_blank"
                                                                               href="/agb">AGB</a></span>
              zur Kenntnis genommen.
            </p>
          </div>
        </div>
      </div>
      <p v-if="errors['start_termsAccepted']" class="mt-2 text-sm text-red-600 error-message">{{errors['start_termsAccepted']}}</p>
    </fieldset>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue';
import { useTenantStore } from "../stores/tenant";

const tenant = useTenantStore();
const errors = computed(() => tenant.errors);

const modelValue = computed({
  get: () => tenant.formValues['start_termsAccepted'] === '1', // Hole den Wert aus dem Store
  set: (newValue) => {
    tenant.setFormValue('start_termsAccepted', newValue ? '1' : ''); // Aktualisiere den Wert im Store
  }
});

watch(modelValue, async (newValue) => {
  await tenant.validateField('start_termsAccepted', newValue ? '1' : '');
});
</script>

